import { Text, Box, Tooltip } from '@mantine/core';
import { useQuery } from '@apollo/client';
import { CuentaNombreDocument } from '../gql/graphql.ts';
import { UserMetadata } from '../Auth/UserMetadataWrapper.tsx';
import { CSSProperties, useContext } from 'react';

/**
 * Este componente trata de identificar la cuenta del usuario.
 *
 * Puede fallar, puntualmente cuando estamos logueados como super admin
 */
export function NombreTienda() {
    const payload = useContext(UserMetadata);
    const cuenta_id =
        'roles' in payload ? payload.roles.at(0)?.cuenta_id : undefined;
    if (cuenta_id) return <NombreTiendaCustomer cuenta_id={cuenta_id} />;
    return null;
}

/**
 * Si hay un cuenta_id, entonces hace la query para obtener el dato
 */
function NombreTiendaCustomer({ cuenta_id }: { cuenta_id: string }) {
    const { data } = useQuery(CuentaNombreDocument, {
        variables: {
            cuenta_id,
        },
    });
    if (data?.cuenta?.nombre)
        return <NombreTiendaPosta nombre={data.cuenta.nombre} />;
    return null;
}

/**
 * Esto es para que el tooltip funcione en mobile
 */
const tooltipEventOptions = { hover: true, focus: true, touch: true };

/**
 * Saaco los estilos afuera del Component por performance
 */
const boxNombreStyle: CSSProperties = {
    maxWidth: 250,
    /**
     * Esto es para que el nombre se tire siempre a la derecha
     */
    marginLeft: 'auto',
};

const nombreStyle: CSSProperties = {
    /**
     * 600 es el valor que usa mantine para las negritas, si ponemos "bold" se ve horrible
     */
    fontWeight: '600',
    fontSize: '1.25rem',
};

/**
 * Este es el componente puro, acá hay que editar la estética
 */
function NombreTiendaPosta({ nombre }: { nombre: string }) {
    return (
        <Tooltip
            //El tooltip solo funciona si el nombre es largo, si no, queda fea
            disabled={nombre.length < 18}
            events={tooltipEventOptions}
            label={nombre}
        >
            <Box style={boxNombreStyle}>
                <Text
                    truncate
                    style={nombreStyle}
                >
                    {nombre}
                </Text>
            </Box>
        </Tooltip>
    );
}
